import useProductAngleImage from '@/shared/product/details/useProductAngleImage';
import { ImageProperties } from '@/types/productServerApi';

export interface ProductImageWithCacheBust {
    maybeAngleImageSku: string;
    version: number;
}

export function useProductImages() {
    const { getMaybeAngleImageSku } = useProductAngleImage();
    const getProductImages = (sku: string, imageProperties: ImageProperties[] = []) => {
        const images: ProductImageWithCacheBust[] = imageProperties.map(properties => ({
            version: properties.version,
            maybeAngleImageSku: getMaybeAngleImageSku(sku, properties),
        }));
        return images;
    };

    return {
        getProductImages,
    };
}
